import { Box, Typography, Button } from "@mui/material";
import { ListTodo } from "lucide-react";
import { Task } from "protogen/tasks_pb";
import { useNavigate } from "react-router-dom";
import useIsMobile from "components/hooks/useIsMobile";
import { defaultTaskSorter } from "components/tasks/TasksTable";
import MemberTaskSection from "components/tasks/MemberTaskSection";
import FlexBox from "components/common/FlexBox";

const TaskList = ({ tasks, loading }: { tasks: Task[]; loading: boolean }) => {
  const navigate = useNavigate();
  const maxVisibleTasks = 5;
  const showMore = tasks.length > maxVisibleTasks;
  const isMobile = useIsMobile();
  const sortedTasks = tasks.sort(defaultTaskSorter);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <FlexBox direction={"row"} justifyContent={"space-between"}>
        <FlexBox direction="row" gap="8px" alignItems="center">
          <ListTodo size={20} color="#198282" />
          <Typography variant={isMobile ? "h3" : "h4"}>Open tasks</Typography>
        </FlexBox>
        {showMore && (
          <Button
            variant="text"
            sx={{ height: "auto" }}
            onClick={() => {
              navigate("/tasks");
            }}
          >
            See all
          </Button>
        )}
      </FlexBox>
      <MemberTaskSection
        tasks={sortedTasks.slice(0, maxVisibleTasks)}
        minimal={true}
        showAddTasksButton={!loading && sortedTasks.length === 0}
        loading={loading}
        compact={true}
      />
      {showMore && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Typography
            variant="body"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/tasks");
            }}
          >
            +{tasks.length - maxVisibleTasks} more
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TaskList;
